import { INDEXDB_COMMON_KEYS, USER_INFO_CACHE_DURATION, CACHE_REFRESH_THRESHOLD } from '@app/consts/common_consts';
import { Cache, CacheProps, ICacheResult } from '../cache';
import { UserInfo } from './types';

export const UserUtils = (() => {
  let userInfo: UserInfo | null = null;
  const init = async (): Promise<void> => {
    const { success, data: cacheValue }: ICacheResult<CacheProps<any>> = await Cache.get(
      INDEXDB_COMMON_KEYS.USER_INFO,
      'indexdb'
    );
    if (success && cacheValue) {
      userInfo = cacheValue?.data || null;
    }
  };

  const set = (user: UserInfo | null): void => {
    userInfo = user;
  };

  const get = (): UserInfo | null => {
    return userInfo || null;
  };

  /**
   * Refresh user info cache if needed (sliding window expiration)
   * Only refreshes if cache is close to expiration (within CACHE_REFRESH_THRESHOLD)
   */
  const refreshCache = async (): Promise<void> => {
    try {
      // Check if user info exists in memory
      if (!userInfo?.user?.userId) {
        return;
      }

      // Get current cache entry
      const cached = await Cache.get(INDEXDB_COMMON_KEYS.USER_INFO, 'indexdb');
      if (!cached.success || !cached.data) {
        return;
      }

      // Check if cache is close to expiration
      const timeRemaining = (cached.data as CacheProps<UserInfo>).staledAt - Date.now();
      if (timeRemaining < CACHE_REFRESH_THRESHOLD) {
        // Refresh cache with new expiration time
        await Cache.upsert(
          INDEXDB_COMMON_KEYS.USER_INFO,
          userInfo,
          'indexdb',
          USER_INFO_CACHE_DURATION
        );
      }
    } catch (error) {
      console.warn('Failed to refresh user cache:', error);
      // Don't throw - cache refresh is non-critical
    }
  };

  return { set, get, init, refreshCache };
})();
